var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _path5, _rect6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigure1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 684,
    height: 61,
    viewBox: "0 0 684 61",
    fill: "figure",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    fill: "url(#figure0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2929 22.7929C92.6834 22.4024 93.3166 22.4024 93.7071 22.7929L100.707 29.7929C101.098 30.1834 101.098 30.8166 100.707 31.2071L93.7071 38.2071C93.3166 38.5976 92.6834 38.5976 92.2929 38.2071C91.9024 37.8166 91.9024 37.1834 92.2929 36.7929L97.5858 31.5H86C85.4477 31.5 85 31.0523 85 30.5C85 29.9477 85.4477 29.5 86 29.5H97.5858L92.2929 24.2071C91.9024 23.8166 91.9024 23.1834 92.2929 22.7929Z",
    fill: "#2D3648"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    width: 60,
    height: 61,
    fill: "url(#figure1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.293 22.7929C216.683 22.4024 217.317 22.4024 217.707 22.7929L224.707 29.7929C225.098 30.1834 225.098 30.8166 224.707 31.2071L217.707 38.2071C217.317 38.5976 216.683 38.5976 216.293 38.2071C215.902 37.8166 215.902 37.1834 216.293 36.7929L221.586 31.5H210C209.448 31.5 209 31.0523 209 30.5C209 29.9477 209.448 29.5 210 29.5H221.586L216.293 24.2071C215.902 23.8166 215.902 23.1834 216.293 22.7929Z",
    fill: "#2D3648"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 0.5,
    width: 61,
    height: 60,
    fill: "url(#figure2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341.293 22.7929C341.683 22.4024 342.317 22.4024 342.707 22.7929L349.707 29.7929C350.098 30.1834 350.098 30.8166 349.707 31.2071L342.707 38.2071C342.317 38.5976 341.683 38.5976 341.293 38.2071C340.902 37.8166 340.902 37.1834 341.293 36.7929L346.586 31.5H335C334.448 31.5 334 31.0523 334 30.5C334 29.9477 334.448 29.5 335 29.5H346.586L341.293 24.2071C340.902 23.8166 340.902 23.1834 341.293 22.7929Z",
    fill: "#2D3648"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 374,
    width: 61,
    height: 61,
    fill: "url(#figure3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M466.293 22.7929C466.683 22.4024 467.317 22.4024 467.707 22.7929L474.707 29.7929C475.098 30.1834 475.098 30.8166 474.707 31.2071L467.707 38.2071C467.317 38.5976 466.683 38.5976 466.293 38.2071C465.902 37.8166 465.902 37.1834 466.293 36.7929L471.586 31.5H460C459.448 31.5 459 31.0523 459 30.5C459 29.9477 459.448 29.5 460 29.5H471.586L466.293 24.2071C465.902 23.8166 465.902 23.1834 466.293 22.7929Z",
    fill: "#2D3648"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 499,
    width: 60,
    height: 61,
    fill: "url(#figure4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M590.293 22.7929C590.683 22.4024 591.317 22.4024 591.707 22.7929L598.707 29.7929C599.098 30.1834 599.098 30.8166 598.707 31.2071L591.707 38.2071C591.317 38.5976 590.683 38.5976 590.293 38.2071C589.902 37.8166 589.902 37.1834 590.293 36.7929L595.586 31.5H584C583.448 31.5 583 31.0523 583 30.5C583 29.9477 583.448 29.5 584 29.5H595.586L590.293 24.2071C589.902 23.8166 589.902 23.1834 590.293 22.7929Z",
    fill: "#2D3648"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 623,
    y: 0.5,
    width: 61,
    height: 60,
    fill: "url(#figure5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "figure0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#figure0_3408_54042",
    transform: "scale(0.0163934)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "figure1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#figure1_3408_54042",
    transform: "scale(0.0166667 0.0163934)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "figure2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#figure2_3408_54042",
    transform: "scale(0.0163934 0.0166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "figure3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#figure0_3408_54042",
    transform: "scale(0.0163934)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "figure4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#figure3_3408_54042",
    transform: "scale(0.0166667 0.0163934)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "figure5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#figure2_3408_54042",
    transform: "scale(0.0163934 0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "figure0_3408_54042",
    width: 61,
    height: 61,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA9CAYAAAAeYmHpAAAACXBIWXMAAAsSAAALEgHS3X78AAAAj0lEQVRoge3awQ2AIBAAwcNYH8XSIBaAp/FDhN15a3IbSPhcSNLqSjJ/3+hkh8Yz+7L39btLuT/TY/okP2A0hdEUyOj0yXpSa5024JvW2ud/vN4URlMYTWE0hdEURlMYTWE0hdEURlMYTWE0hdEURlMYTWE0hdEU6ZrkRhuDQ6PXm8JoCqMpkJv9krS2iLgAxCAMaCJG74EAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "figure1_3408_54042",
    width: 60,
    height: 61,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA9CAYAAADxoArXAAAACXBIWXMAAAsSAAALEgHS3X78AAACJUlEQVRoge2asZJBMRSGz+xsRa+npqZXo6bmJShoeAo1NWq9nppeT3t3/jubGbNzd8jJSa4b55u5HTn/l5BEghRFUYrOjIiSSJ7Z37H4yhqc6XRKSZIU+oFDFpnCMaPCsaPCsfNxwt++CxwOBzoej3S5XOh0OmW+pl6vU7VapUajQa1Wy2seL8K324222y1tNhu63+9PX4+OwLPb7ahUKlGv16Nut0vlclk8m7gwRFer1UuiWeB96/U67azBYJCKSyImjFGdz+f/fmw54svlMv1KTCYTsdEWmbQgOx6PxWQfQZtoGzUkcBY2spiUfIG2paSdhEPIGqSknYQxOYWQNaAWarrAFsbaimUkNKiJ2lzYwlg68sKlNksYPexjRn4V1OaOMkt4v98LxHaDm4EljM1A3nAzWAufz2f2tlESZEAWW6yFQy5Dz+BksRa+Xq8CUWXgZNETj9hR4dixFq5UKm/TJZws1sI4bHsXOFmshWu1WnrQljfIgCzehYHvo1SfGVjC7XabVUwSbgaWMA7McXieF6iNDMGEQb/fz03YpTZbGD3c6XTYhbmgJnd0yXXjgZuBkMsUao1GI6c2nIRxG7BYLIJIowZqueK8tQwhbWQlrltE9tJG2sfM3Ww2xWRJ8seDkR4OhyI7MbSBtiQv0sjHdSmuN7EpsLkffqRw98P0O9pYK/F8xD8AHoHAO+y9DXoAEDsqHDsq/IlE/Y94RVGU4kBEP1yO20J6fYeUAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "figure2_3408_54042",
    width: 61,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA8CAYAAADVPrJMAAAACXBIWXMAAAsSAAALEgHS3X78AAADTklEQVRoge2b3WriQBTHZ1ep8SMQehFFAmvBQm8KfYS+0foG+gjuS+i14m2Ll70s6EVBERdCES+K4EdjUViOOCB6oslkzmSr+UFATWcmf3+TNDmdsoiIiLPih4cwD4wxQyC0sW2Lcnd3l0un0xq27+PjIzedTnPYvng8Hs9kMhm3fvv9/i/+2rKsP7Ztlw76QNpVGGNl/iaXyzn5fN7BBkgkEtrV1RV64MDj46PbrqMYhsEeHly/r6NAO2hfqVRYq9UybNs++HEsNCuXy5tGW7Ttdjb8PKcw+3x+fqKnARZ6+Pr6qvTgKIBTazweF7Gu0dCTyeTbhfTDWU9vN6LQKnl5eQlr6HBCPz09sWq1yubzeRjDhxO6Xq+zxWLBms1mGMPjodfr9YpqQLA8Ho83rxuNBqltA27NENDQi8ViRnUgYHlnnFBsK53ecPHiljlge/8zapSGxqyC7VqtpvIw1IXudDqs2+2i+56fn5XaVhZ691zGUGlbSehjljkqbaOhp9Mp+pwtyinLHJm2C4UCs20brb5godu9Xs+1HOMXsHfKMgdsw6yQAYR2HCfhNbRU/NrzOiuCQBoaLIM9P8CskGXbDdLQoucotW2y0CKWOdS2yUIHvRJT2iYJDU9OQYsEYBueyCggCQ332HBPHRQq29JDg2V4cpIBXBcobEsPLcsyh8K21NAyLXMobEsNDQcn0zIHbMssK0kNTVX6Adsy+5YWerfgR4HMIiIaWtO05XA49NUR9a2jSBHx9vYWCpwHfyRHQ1uWNfITmtoyx69tXdfRUraU6a3icZBJLBkHDq3KMkdGyVhKaJXIKBkHCu2l4EdB0CJioNCqzmWMILaFQ4dlmePFdiqV8rzQhk08LDoJ0zLnlO1YLIaWsoVMDwaDUC1zREvGQkX93d+VNzc3LJ1Oi3TD7u/vhdqZprnZgGw267u9UOhSqbTZvivR6qJL4RJCF/Y/QEObptlvt9tKjoiS7dJrb6GTySTZQpv/gZNXb7hPEV0VDO1EF9cem2lfX1/OcrlEF96/v79ro9Ho6Pp09N8ZLMuq2rb9m78vFot/3TqYzWaz1WqFPqzruj66vr4eYfvm87nz9vaG7tsC37TINzbZto2IiLgEGGP/AGWDmZU65l1nAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "figure3_3408_54042",
    width: 60,
    height: 61,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA9CAYAAADxoArXAAAACXBIWXMAAAsSAAALEgHS3X78AAAAdElEQVRoge3awQkDMRAEwcWJ6zKX8fdQAmpXwQbQzHcH4HbPzOzIPe8tPqdx1lqz9776fg0nx+AywXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5w3d8Fn6Q/4gHuMTNf/UP4aSlQTZAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure1);
export default __webpack_public_path__ + "static/media/figure1.bcb8d20ba74f5f9f3bdd317b9d3798d4.svg";
export { ForwardRef as ReactComponent };